import { UserDetails } from "@users/models/user-details.state";
import { createAction, props } from "@ngrx/store";

export const loadUserDetails = createAction(
  "[UserDetails/API] Load UserDetails",
  props<{ userDetailsId: string }>()
);
export const loadUserDetailsSuccess = createAction(
  "[UserDetails/API] Load UserDetails Success",
  props<{ userDetails: UserDetails }>()
);
export const loadUserDetailsFailure = createAction("[UserDetails/API] Load UserDetails Failure");
export const loadUserDetailsNotFound = createAction("[UserDetails/API] Load UserDetails Not Found");

export const deleteUserDetails = createAction(
  "[UserDetails/API] Delete UserDetails",
  props<{ userDetails: UserDetails }>()
);
export const deleteUserDetailsSuccess = createAction(
  "[UserDetails/API] Delete UserDetails Success",
  props<{ userDetailsId: string }>()
);
export const deleteUserDetailsFailure = createAction(
  "[UserDetails/API] Delete UserDetails Failure"
);

export const enableUser = createAction(
  "[UserDetails/API] Enable User",
  props<{ userId: string }>()
);
export const enableUserSuccess = createAction(
  "[UserDetails/API] Enable User Success",
  props<{ userId: string }>()
);
export const enableUserFailure = createAction("[UserDetails/API] Enable User Failure");

export const disableUser = createAction(
  "[UserDetails/API] Disable User",
  props<{ userId: string }>()
);
export const disableUserSuccess = createAction(
  "[UserDetails/API] Disable User Success",
  props<{ userId: string }>()
);
export const disableUserFailure = createAction("[UserDetails/API] Disable User Failure");

export const resetAppCode = createAction(
  "[UserDetails/API] Reset App Code",
  props<{ userId: string }>()
);
export const resetAppCodeSuccess = createAction(
  "[UserDetails/API] Reset App Code Success",
  props<{ userId: string }>()
);
export const resetAppCodeFailure = createAction("[UserDetails/API] Reset App Code Failure");

export const resetWebauthn = createAction(
  "[UserDetails/API] Reset Webauthn",
  props<{ userId: string }>()
);
export const resetWebauthnSuccess = createAction(
  "[UserDetails/API] Reset Webauthn Success",
  props<{ userId: string }>()
);
export const resetWebauthnFailure = createAction("[UserDetails/API] Reset Webauthn Failure");
